var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"monthly-wrapper"}},[_c('vue-monthly-picker',{attrs:{"value":_vm.value,"monthLabels":_vm.monthLabels,"max":_vm.maxMonthToBeSelected,"dateFormat":_vm.MONTHLY_PICKER_FORMAT,"clear-option":false},on:{"selected":function (date) { return _vm.$emit('input', date); }}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b008c600","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/VectorWidgets/ux/MonthPicker.vue
// module id = null
// module chunks = 